import React from 'react';
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";

import { FormInputDatePicker } from "../../../ReactHookForm/FormComponents";

import {UserTypes} from "root/DataFunctions/Constants";
import DropdownUsers from "root/ReactHookForm/ui/DropdownUsers";

const HookSubFormCarer = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const validateCarer = (val) =>
    {
        if (val === null)
        {
            return "Please Select a carer.";
        }
    }

    return (
        <FieldsetContainer title='Carer' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={6}>
                    <label className='col-form-label'>Select a carer (Use the filter to narrow down the list)</label>
                    <DropdownUsers name={sectionName + '.carer_id'} user_type={UserTypes.CARER} control={control} rules={{validate: validateCarer}}
                                                      placeHolder='Pick a carer' readOnly={readOnly} isSearchable={true}/>
                    {formErrors[sectionName]?.carer_id?.type === 'validate' && <ErrorDiv>Please select a carer</ErrorDiv>}

                </BootstrapCol>
                <BootstrapCol width={6}>
                    <FormInputDatePicker readOnly={readOnly} label='Date Care Started' sectionName={sectionName}
                                         name={'date_care_started'}
                                         control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow>

        </FieldsetContainer>
    )
}


export default HookSubFormCarer;
